import { render, staticRenderFns } from "./VehicleViewLogs.vue?vue&type=template&id=b6c4eec6"
import script from "./VehicleViewLogs.vue?vue&type=script&lang=js"
export * from "./VehicleViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports